<template>
  <el-select v-model="values" :multiple="multiple" :remote-method="remoteMethod" @blur="handleBlur"
             @change="handleChange" @clear="handleClear" @focus="handleFocus" @remove-tag="handleRemoveTag"
             @visible-change="handleVisibleChange" :reserve-keyword="reserveKeyword" :loading="loading" :filterable="filterable"
             :clearable="clearable" :remote="remote" :placeholder="placeholder" style="width: 66%" >
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="{label:item.label,value:item.value}">
    </el-option>
  </el-select>
</template>

<script>
var observer = null
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    placeholder: String,
    maxCount: {
      type: Number,
      default: 2
    },
    remoteMethod: Function,
    multiple: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: false
    },
    reserveKeyword: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    myClass: String,
  },
  data() {
    return {
      tagSpanDom: null,
      hideDom: null
    };
  },
  mounted() {
    let tagLIstDom = document.querySelector("." + this.myClass);
    //   需要加上组件自定义的类名，防止监听失效
    let tagSpanDom = document.querySelector("." + this.myClass + " .el-select__tags > span");
    this.tagSpanDom = tagSpanDom;
    let hideDom = document.createElement("span");
    this.hideDom = hideDom;
    hideDom.classList = ["counts-node"]; //设置样式
    var config = {
      childList: true
    };
    // this.init();
    // 当观察到突变时执行的回调函数
    let _this = this;
    var callback = function(mutationsList) {

      mutationsList.forEach(function(item, index) {
        if (item.type == "childList") {
          let tagList = item.target.childNodes;
          let tagWidth = 0; //标签总宽度
          let tagNum = 0; //标签多余个数
          let avaliableTagWidth = 0 //显示标签的总宽度
          for (let i = 0; i < tagList.length; i++) {
            const e = tagList[i];
            if (!e.classList.contains("count-node")) {
              if (i >= _this.maxCount && tagList.length > 3) {
                e.style.display = "none"; //隐藏多余标签
                _this.hideDom.style.display = "inline-block"; //显示多余标签个数
                _this.hideDom.style.left = `${avaliableTagWidth}px` //数字标签的位置设置
                _this.hideDom.innerHTML = `+${tagList.length -2- tagNum}`; //显示多余标签个数
              } else {
                e.style.display = "inline-block";
                tagNum++;
                _this.hideDom.style.display = "none"; //隐藏多余标签个数
                const margin = tagNum === 1 ? 0 : 7
                avaliableTagWidth += e.offsetWidth + margin
              }
            }
          }
        }
      });
    };
    observer = new MutationObserver(callback);
    observer.observe(tagSpanDom, config);
  },
  methods: {
    init() {
      let tagNum = this.value.length-this.maxCount; //标签多余个数
      let avaliableTagWidth = 0 //显示标签的总宽度
      if(tagNum>0){
        this.hideDom.style.display = "inline-block"; //显示多余标签个数
        this.hideDom.style.left = `${avaliableTagWidth}px` //数字标签的位置设置
        this.hideDom.innerHTML = `+${tagNum}`; //显示多余标签个数
      }
    },
    handleBlur(event) {
      this.$emit('blur', event)
    },
    handleChange(value) {
      this.hideDom.remove();
      this.tagSpanDom.append(this.hideDom); //插入到span中
      this.$emit('change', value)
    },
    handleClear() {
      this.$emit('clear')
      this.hideDom.style.display = "none";
    },
    handleFocus(event) {
      this.$emit('focus', event)
    },
    handleRemoveTag(tag) {
      this.$emit('remove-tag', tag)
    },
    handleVisibleChange(visible) {
      this.$emit('visible-change', visible)
    },
    focus() {
      this.$refs.select.focus()
    },
    blur() {
      this.$refs.select.blur()
    }
  },
  computed: {
    values: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  //销毁时
  beforeDestroy() {
    // 停止观察
    observer.disconnect();
  }
};
</script>
<style>
.counts-node {
  top: 2px;
  display: none;
  height: 24px;
  padding: 0 8px;
  line-height: 22px;
  margin-left: 6px;
  background-color: #f4f4f5;
  border: 1px solid #e9e9eb;
  border-radius: 4px;
  color: #909399;
  font-size: 12px;
  box-sizing: border-box;
}
.select-hospname-tags .el-select__tags .el-tag--info {
  max-width: 100px;
  //overflow: hidden;
  //text-overflow: ellipsis;
  //white-space: nowrap;
}
.select-hospname-tags .el-select__tags .el-tag--info .el-select__tags-text {
  display: inline-block;
  max-width: 82%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-select .el-tag__close.el-icon-close {
  top: -8px;
}
::v-deep .el-select.select-hospname-tag{
  width: 66%!important;
}
</style>
